import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { entAnimations } from 'src/app/animations';
import { RouteStatusService } from 'src/app/services/maintenance/route-status.service';
import { RouteStatus } from 'src/app/models/services/maintenance/routeStatus.model';
import { KeycloakService } from 'src/app/services/keycloak/keycloak.service';
import { UsersService } from 'src/app/services/users/users.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maintenance-dialog',
  templateUrl: './maintenance-dialog.component.html',
  styleUrl: './maintenance-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class MaintenanceDialogComponent implements OnInit {
  items: RouteStatus[];
  showOnlyFullMaintenance = false;

  constructor(
    public dialogRef: MatDialogRef<MaintenanceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { changedItems: RouteStatus[] },
    private _routeStatusService: RouteStatusService,
    private _userService: UsersService,
    private _keycloakService: KeycloakService
  ) {
    this.items = data.changedItems; // Assign passed data to items
  }

  ngOnInit(): void {
    // Check if full maintenance to display correctly in dialog
    this.showOnlyFullMaintenance = this.items.some(item => item.url === '/*');
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  //Logout
  logout(): void {
    this._userService.clearStorageAndLogout();
    this._keycloakService.logout(environment.logoutURL);
  }

  save(): void {
    // Save logic here
    this._routeStatusService.updateMaintenanceSettings(this.items).subscribe({
      next: () => this.logout(),
      error: e => console.log(e),
    });
  }
}
